import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode"; // Corrected import
import {
  ShowUsersInfo,
  UpdateUser,
} from "../../../context/Slice/RegisterSlice";
import {
  AddEventCoordinatorDetails,
  ShowOneCoordinatorDetail,
} from "../../../context/Slice/CoordinatorManagementSlice";
import { ShowAllServiceLocation } from "../../../context/Slice/VendorManagementSlice";
import "./CoordinatorProfile.css"; // Import the CSS file
import { lookup } from "../../Vendor/VendorScenes/Profile/index";
import Select from "react-select";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CoordinatorProfile = () => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  const EventCoordinatordetails = useSelector(
    (state) => state.CoordinatorManagementR.Data
  );
  const UserInfo = useSelector((state) => state.RegisterR.AlluserData);

  const [formValues, setFormValues] = useState({
    id: "",
    CoordinatorsImage: "",
    OtherMobile_number: "",
    Whatsapp_number: "",
    Gender: "",
    DOB: "1-1-2025",
    City: "",
    ADDRESS: "",
    Languages: "",
    Educational_details_if_related_to_work: "",
    Experience: "",
    Small_description: "",
  });

  const [LoginValues, setLoginValues] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile_number: "",
  });

  const [imagePreview, setImagePreview] = useState({
    CoordinatorsImage: "",
  });

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [pinCodeError, setPinCodeError] = useState("");
  const navigate = useNavigate();

  const token = secureLocalStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setFormValues((prevValues) => ({
        ...prevValues,
        id: decoded._id,
      }));
      setLoginValues((prevValues) => ({
        ...prevValues,
        id: decoded._id,
      }));
      dispatch(ShowOneCoordinatorDetail(decoded._id));
      dispatch(ShowUsersInfo(decoded._id));
      dispatch(ShowAllServiceLocation());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (EventCoordinatordetails && EventCoordinatordetails.length > 0) {
      const details = EventCoordinatordetails[0];
      const parsedCoordinatorsImage = JSON.parse(
        details.CoordinatorsImage || "[]"
      );

      const coordinatorsImageFilename =
        parsedCoordinatorsImage[0]?.filename || "";

      setFormValues((prevValues) => ({
        ...prevValues,
        OtherMobile_number: details.OtherMobile_number || "",
        Whatsapp_number: details.Whatsapp_number || "",
        Gender: details.Gender || "",
        DOB: details.DOB ? details.DOB.split("T")[0] : 10 - 12 - 1996,
        City: details.City || "",
        ADDRESS: details.ADDRESS || "",
        Languages: details.Languages || "",
        Educational_details_if_related_to_work:
          details.Educational_details_if_related_to_work || "",
        Experience: details.Experience || "",
        Small_description: details.Small_description || "",
        CoordinatorsImage: coordinatorsImageFilename
          ? `${BASE_URL}/Uploads/${coordinatorsImageFilename}`
          : "",
      }));

      setImagePreview({
        CoordinatorsImage: coordinatorsImageFilename
          ? `${BASE_URL}/Uploads/${coordinatorsImageFilename}`
          : "",
      });
    }

    setLoginValues({
      firstName: UserInfo.firstName || "",
      lastName: UserInfo.lastName || "",
      email: UserInfo.email || "",
      mobile_number: UserInfo.mobile_number || "",
    });
  }, [EventCoordinatordetails, UserInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (Object.keys(LoginValues).includes(name)) {
      setLoginValues({
        ...LoginValues,
        [name]: value,
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  const handlePinCodeChange = (event) => {
    const { value } = event.target;
    setFormValues((prev) => ({ ...prev, ADDRESS: value }));
    setShowSuggestions(true);

    // Get the location value dynamically from the location field
    const City = formValues.City.toLowerCase(); // Case-insensitive check for location

    if (City) {
      if (value.length >= 3) {
        // Dynamically filter pincodes based on districtName matching the entered location
        const filteredSuggestions = lookup(value)
          .filter(
            (suggestion) => suggestion.districtName.toLowerCase().includes(City) // Match district name
          )
          .slice(0, 10); // Limit to top 10 suggestions
        setSuggestions(filteredSuggestions);

        // Check if pincode matches city
        const isValidPinCode = filteredSuggestions.some((suggestion) =>
          suggestion.districtName.toLowerCase().includes(City)
        );
        if (!isValidPinCode) {
          setPinCodeError("The pincode does not match the selected city.");
        } else {
          setPinCodeError(""); // Clear error if valid pincode
        }
      } else {
        setSuggestions([]); // If pin code length is less than 3, clear suggestions
      }
    } else {
      setSuggestions([]); // If location is empty, clear suggestions
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setFormValues((prev) => ({
      ...prev,
      ADDRESS: suggestion.officeName,
    }));
    setSuggestions([]); // Clear suggestions
    setShowSuggestions(false); // Hide suggestions
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      const file = files[0];
      setFormValues({
        ...formValues,
        [name]: file,
      });
      setImagePreview({
        ...imagePreview,
        [name]: URL.createObjectURL(file),
      });
    }
  };
  console.log(formValues);

  const handleRemoveImage = (name) => {
    setFormValues({
      ...formValues,
      [name]: "",
    });
    setImagePreview({
      ...imagePreview,
      [name]: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formValues);
    dispatch(AddEventCoordinatorDetails(formValues));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const updatedLoginValues = { ...LoginValues, id: formValues.id };
    dispatch(UpdateUser(updatedLoginValues));
    console.log(updatedLoginValues);
  };
  const HandleBack = () => {
    navigate("/co-ordinator-dashboard");
  };
  return (
    <div id="Profile-body" className="ProfileBody">
      <div className="container-xl px-4 mt-4">
        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <hr className="mt-0 mb-4" />
        <div className="row">
          <div className="col-xl-4">
            <div className="card mb-4 mb-xl-0">
              <div className="card-header">Profile Picture</div>
              <div className="card-body text-center">
                <img
                  className="img-account-profile rounded-circle mb-2"
                  src={
                    imagePreview.CoordinatorsImage ||
                    "http://bootdey.com/img/Content/avatar/avatar1.png"
                  }
                  alt="Profile"
                />
                <div className="small font-italic text-muted mb-4">
                  JPG or PNG no larger than 5 MB
                </div>

                <input
                  type="file"
                  id="profilePictureInput"
                  className="d-none"
                  accept="image/*"
                  name="CoordinatorsImage"
                  onChange={handleFileChange}
                />
                <label
                  htmlFor="profilePictureInput"
                  className="btn btn-primary"
                >
                  Upload new image
                </label>
                {/* {formValues.CoordinatorsImage && (
                  <div className="mt-2">
                    <small>
                      Image Path: {formValues.CoordinatorsImage.name}
                    </small>
                  </div>
                )} */}
                {formValues.CoordinatorsImage && (
                  <button
                    type="button"
                    onClick={() => handleRemoveImage("CoordinatorsImage")}
                    className="btn btn-danger  mt-2"
                  >
                    Remove Image
                  </button>
                )}
              </div>
            </div>
            <div className="card mt-3 mb-xl-0">
              <div className="card-header">Login Details</div>
              <form onSubmit={handleUpdate} autoComplete="off">
                <div className="card-body">
                  <div className="col-md-12 mt-2">
                    <label className="small mb-1" htmlFor="firstName">
                      First Name
                    </label>
                    <input
                      className="form-control"
                      id="firstName"
                      name="firstName"
                      type="text"
                      placeholder="Enter first name"
                      value={LoginValues.firstName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="small mb-1" htmlFor="lastName">
                      Last Name
                    </label>
                    <input
                      className="form-control"
                      id="lastName"
                      name="lastName"
                      type="text"
                      placeholder="Enter last name"
                      value={LoginValues.lastName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="small mb-1" htmlFor="email">
                      Email
                    </label>
                    <input
                      className="form-control"
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter email"
                      value={LoginValues.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-12 mt-2">
                    <label className="small mb-1" htmlFor="mobile_number">
                      Mobile Number
                    </label>
                    <input
                      className="form-control"
                      id="mobile_number"
                      name="mobile_number"
                      type="tel"
                      placeholder="Enter mobile number"
                      value={LoginValues.mobile_number}
                      onChange={handleChange}
                    />
                  </div>
                  <button className="btn btn-primary mt-3" type="submit">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="card mb-4">
              <div className="card-header">Coordinator Details</div>
              <div className="card-body">
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label
                        className="small mb-1"
                        htmlFor="OtherMobile_number"
                      >
                        Business Mobile Number
                      </label>
                      <input
                        className="form-control"
                        id="OtherMobile_number"
                        name="OtherMobile_number"
                        type="text"
                        placeholder="Enter other mobile number"
                        value={formValues.OtherMobile_number}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="Whatsapp_number">
                        Business Whatsapp Number
                      </label>
                      <input
                        className="form-control"
                        id="Whatsapp_number"
                        name="Whatsapp_number"
                        type="text"
                        placeholder="Enter Whatsapp number"
                        value={formValues.Whatsapp_number}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label className="small mb-1">Gender</label>
                      <div>
                        <input
                          type="radio"
                          id="male"
                          name="Gender"
                          value="male"
                          checked={formValues.Gender === "male"}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="male" className="ms-1">
                          Male
                        </label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="female"
                          name="Gender"
                          value="female"
                          checked={formValues.Gender === "female"}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="female" className="ms-1">
                          Female
                        </label>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <label className="small mb-1" htmlFor="DOB">
                        Date of Birth
                      </label>
                      <input
                        className="form-control"
                        id="DOB"
                        name="DOB"
                        type="date"
                        value={formValues.DOB}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-md-6 left-border">
                      <label className="small mb-1" htmlFor="inputOwnerDOB">
                        City
                      </label>
                      <div
                        className="input-group"
                        style={{ position: "relative", zIndex: 10 }}
                      >
                        <Select
                          className="form-control listing-category category-input"
                          placeholder="Select City"
                          options={locations.map((location) => ({
                            value: location.LocationName, // Store value as LocationName directly
                            label: location.LocationName, // Display LocationName as label
                          }))}
                          onChange={(selectedOption) => {
                            setFormValues((prev) => ({
                              ...prev,
                              City: selectedOption ? selectedOption.value : "", // Store the selected city's value
                            }));
                          }}
                          value={
                            formValues.City
                              ? {
                                  label: formValues.City,
                                  value: formValues.City,
                                }
                              : null
                          } // Set default value if exists
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label>Coordinator Business Address</label>
                      <input
                        className="form-control"
                        type="text"
                        name="city"
                        value={formValues.ADDRESS}
                        onChange={handlePinCodeChange}
                        placeholder="Enter Area Name or Pin Code"
                      />
                      {pinCodeError && (
                        <div className="error-message">{pinCodeError}</div>
                      )}
                      {showSuggestions && suggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {suggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              className="suggestion-item"
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion.officeName} ({suggestion.pincode})
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div
                      className="col-md-6"
                      style={{ position: "relative", zIndex: 9 }}
                    >
                      <label className="small mb-1" htmlFor="Languages">
                        Languages
                      </label>
                      <Select
                        isMulti
                        value={JSON.parse(formValues.Languages || "[]").map(
                          (lang) => ({
                            label: lang,
                            value: lang,
                          })
                        )}
                        onChange={(selectedOptions) => {
                          setFormValues((prev) => ({
                            ...prev,
                            Languages: JSON.stringify(
                              selectedOptions
                                ? selectedOptions.map((opt) => opt.value)
                                : []
                            ),
                          }));
                        }}
                        options={[
                          "Hindi",
                          "English",
                          "Marathi",
                          "Tamil",
                          "Telugu",
                          "Bengali",
                        ].map((lang) => ({
                          label: lang,
                          value: lang,
                        }))}
                      />

                      {/* <input
                        className="form-control"
                        id="Languages"
                        name="Languages"
                        type="text"
                        placeholder="Enter languages"
                        value={formValues.Languages}
                        onChange={handleChange}
                      /> */}
                    </div>
                    <div className="col-md-6">
                      <label
                        className="small mb-1"
                        htmlFor="Educational_details_if_related_to_work"
                      >
                        Educational Details (if related to work)
                      </label>
                      <select
                        className="form-control"
                        id="Educational_details_if_related_to_work"
                        name="Educational_details_if_related_to_work"
                        value={
                          formValues.Educational_details_if_related_to_work
                        }
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select educational details
                        </option>
                        <option value="Graduate">Graduate</option>
                        <option value="Post Graduate">Post Graduate</option>
                        <option value="PhD">PhD</option>
                        <option value="Diploma">Diploma</option>
                        <option value="High School">High School</option>
                      </select>
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="Experience">
                        Experience (in years)
                      </label>
                      <select
                        className="form-control"
                        id="Experience"
                        name="Experience"
                        value={formValues.Experience}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select experience
                        </option>
                        {Array.from({ length: 30 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1} Year{i + 1 > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="Small_description">
                        Small Description
                      </label>
                      <input
                        className="form-control"
                        id="Small_description"
                        name="Small_description"
                        type="text"
                        placeholder="Enter small description"
                        value={formValues.Small_description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                 
                    <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                  
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoordinatorProfile;
